import React from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import Currency from './Currency';
import Auth from './Auth/Auth';
import history from './history';

const auth = new Auth();

export const makeMainRoutes = () => {
  return (
    <Router history={history}>
     <Switch>
       <Route path="/" render={(props) => {
         return <Currency auth={auth} {...props} />
       }}/>
     </Switch>
   </Router>
  );
}
